var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7132 14.2C17.7775 13.1628 19.354 12.3705 19.4974 12.2983C19.9252 12.0834 20.3734 11.5348 19.4974 11.0964C19.2159 10.9552 17.6817 10.1872 15.7108 9.20001L13 11.7078L15.7132 14.2Z",
    fill: "#FFE300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3781 11.2L5 20.1939C5.1892 20.2195 5.41676 20.1661 5.67851 20.0134C6.22041 19.6975 12.04 16.3037 16 13.9945L13.3781 11.2Z",
    fill: "#FF4E54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3814 11.2L16 8.68781C16 8.68781 6.26698 3.63223 5.6843 3.32959C5.46033 3.21322 5.21614 3.17261 5 3.21844L13.3814 11.2Z",
    fill: "#00F085"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11.6717L4.6291 3.20001C4.28335 3.27805 4 3.58083 4 4.18943V19.1836C4 19.7567 4.2229 20.1598 4.6351 20.2L13 11.6717Z",
    fill: "#00E0FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google_play.57f11f0af3992dba990579d4648568a7.svg";
export { ForwardRef as ReactComponent };